export enum EntityType {
  PHARMACY = 'PHARMACY',

  DIAGLAB = 'DIAGLAB',
}
